<template>
  <svg
    class="cluster-wrap-vector pointer-events-none position-relative"
    :viewBox="'0 0 375 ' + data.height"
    xmlns="http://www.w3.org/2000/svg"
    :data-key="uuid"
    :height="vectH"
    :style="[ isIE ? { marginTop: '60px' } : {} ]"
  >

    <cluster-fragment
      v-for="(pt, idx) in data.points"
      :key="idx"
      :idx="idx"
      :ind-override="indOverride"
      :percent-size="pt[industry].fontSize"
      :active="active"
      :label="{ title: pt.title, pos: 'bottom', align: 'center' }"
      :target="pt[industry].num"
      :data="pt[industry]"
      :bg="bg"
      :angle="data.gradAngle"
      @activated.once="activated = true"
    />

  </svg>
</template>

<script>
  import GraphMixin from '@/components/report/mixins/GraphMixin'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import ClusterFragment from '@/components/report/content/ClusterFragment'

  export default {
    name: 'Cluster',
    mixins: [ ContentMixin, GraphMixin ],
    watch: {
      data () {
        this.$emit( 'toggle-ind' )
      }
    },
    components: { ClusterFragment }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .cluster-wrap-vector {
    width     : calc(100% + #{$content-pad-x * 2});
    max-width : 500px;
    left      : -$content-pad-x;

    @include screen-md-lg-xl {
      margin : 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Cluster.vue